var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6663 11.8773V13.619C10.9121 13.3523 10.1049 13.2705 9.31251 13.3805C8.52012 13.4904 7.76567 13.7889 7.11253 14.2508C6.45939 14.7128 5.92663 15.3247 5.55898 16.0352C5.19132 16.7457 4.99952 17.534 4.99967 18.334L3.33301 18.3332C3.33275 17.3156 3.56544 16.3114 4.01326 15.3976C4.46107 14.4839 5.11212 13.6848 5.91652 13.0615C6.72092 12.4383 7.65732 12.0074 8.65397 11.802C9.65062 11.5966 10.6811 11.6229 11.6663 11.8773ZM9.99967 10.834C7.23717 10.834 4.99967 8.59648 4.99967 5.83398C4.99967 3.07148 7.23717 0.833984 9.99967 0.833984C12.7622 0.833984 14.9997 3.07148 14.9997 5.83398C14.9997 8.59648 12.7622 10.834 9.99967 10.834ZM9.99967 9.16732C11.8413 9.16732 13.333 7.67565 13.333 5.83398C13.333 3.99232 11.8413 2.50065 9.99967 2.50065C8.15801 2.50065 6.66634 3.99232 6.66634 5.83398C6.66634 7.67565 8.15801 9.16732 9.99967 9.16732ZM14.9997 14.1673V11.6673H16.6663V14.1673H19.1663V15.834H16.6663V18.334H14.9997V15.834H12.4997V14.1673H14.9997Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/Signup.31f91ca921e4b525c092b394c2424eb3.svg";
export { ForwardRef as ReactComponent };